module.exports = __webpack_public_path__ + "img/icon_usd.1c4376b0.svg";